export default angular
  .module('doxy.realtime.common.services.youtubeService', [])
  .service('youtubeService', function () {
    function exitFullscreen() {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    }
    function pauseVideo() {
      const youtubeFrames = document.querySelectorAll(
        'iframe[src*="youtube.com"]'
      );
      const vimeoFrames = document.querySelectorAll(
        'iframe[src*="player.vimeo.com"]'
      );
      Array.prototype.forEach.call(youtubeFrames, (frame) => {
        frame.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
      });
      Array.prototype.forEach.call(vimeoFrames, (frame) => {
        const command = {
          event: 'command',
          method: 'pause',
          value: 'true',
        };
        frame.contentWindow.postMessage(JSON.stringify(command), '*');
      });
    }

    return {
      exitFullscreen,
      pauseVideo,
    };
  }).name;
